import { GTM_LOADED_EVENT } from '@lib/constants/gtm';
import Script from 'next/script';

type Props = {
  containerId?: string;
};

export default function GoogleTagManager({ containerId }: Props) {
  return (
    <Script
      id="googleTagManager"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        /**
         * Note that the Custom Event being fired in the 2nd block below
         * is custom code that we've added to allow us to fire events
         * once GTM has loaded. If you replace this code, make sure that
         * other code that relies on `GTM_LOADED_EVENT` still works.
         */
        __html: `
          window.dataLayer = window.dataLayer || [];
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;
          
          j.addEventListener('load', function() {
            var _ge = new CustomEvent('${GTM_LOADED_EVENT}', { bubbles: true });
            d.dispatchEvent(_ge);
          });

          f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer', '${containerId}');
        `,
      }}
    />
  );
}
